module.exports = __webpack_public_path__ + "img/category-skill-game.48336607.png";